import { CAPABILITIES } from '../../../src/utils/accountUtils';

export const currentAccount = {
	id: '0e4951cf-5134-42d1-8e46-4e52f21d053f',
	type: 'current',
	number: '826817-50017756',
	sortCode: '826817',
	accountNumber: '50017756',
	accountName: 'Current Account 1',
	product: { code: '220', name: 'Business Current', description: 'STANDARD BUSINESS' },
	actionsAvailable: {
		'/account/securemessage/read': false,
		'/account/payments/swift/out': false,
		'/account/transactions/readwrite': false,
		'/account/mandates/so/write/recurring': false,
		'/account/sweeps/transfer/out': false,
		'/users/preferences/write': false,
		'/account/books/payin/reorder': false,
		'/account/transactions/write': false,
		'/account/payments/batch/out': false,
		'/account/mandates/so/update': false,
		'/account/sweeps': false,
		'/account/beneficiaries/delete': true,
		'/account/payments/read': false,
		'/account/payments/uk/ics/in': false,
		'/users/read': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/payments/uk/default/out': true,
		'/users/details/write': false,
		'/users/write': false,
		'/account/payments/templates/readwrite': false,
		'/account/transactions/read': true,
		'/account/pots': false,
		'/account/payments/bacscredit/out': true,
		'/account/mandates/so/write': true,
		'/account/payments/transfer/in': true,
		'/user/write': false,
		'/account/statements/order': false,
		'/account/mandates/so/read': true,
		'/account/books/cheque/reorder': false,
		'/account/beneficiaries/import': false,
		'/account/beneficiaries/read': true,
		'/account/beneficiaries/biller/write': true,
		'/account/payments/list/out': false,
		'/account/projections': false,
		'/account/read/limited': false,
		'/account/beneficiaries/account/readwrite': true,
		'/account/preferences/paperstatementoptout': false,
		'/account/payments/transfer/out': true,
		'/users/preferences/read': false,
		'/users/security_device/write': false,
		'/account/alerts': true,
		'/account/consent': false,
		'/users/permissions/write': false,
		'/account/read': true,
		'/account/mandates/dd/read': true,
		'/account/statements/read': false,
		'/account/payments/bacsdebit/out': false,
		'/account/securemessage/write': false,
		'/account/mandates/dd/write': true,
		[CAPABILITIES.IFT]: true,
		[CAPABILITIES.CHAPS]: true,
		[CAPABILITIES.EFFECTIVEWARNING]: false,
	},
	bank_id: 'CB',
	metadata: { display_name: null, display_order: 0, account_name: 'Joes Carpeneter Business Account' },
	displayName: 'Business Current no approval',
	balances: [
		{ type: 'current', amount: { value: 500, currency: 'GBP' } },
		{ type: 'available', amount: { value: 500, currency: 'GBP' } },
	],
	code: null,
	showIcon: null,
	display_order: 1,
	bacs: [
		{
			id: '123456',
			type: 'BCR',
			limit: 5000,
			limit_frequency: 'Daily',
		},
	],
};

export const creditCard = {
	id: '31c99053-b219-4c52-8753-e9311a5e87da',
	type: 'credit_card',
	number: '************8214',
	accountName: 'Credit Card 1',
	sortcode: null,
	product: { code: '0001', name: 'CREDIT CARD', description: 'CREDITCARD' },
	actionsAvailable: {
		'/account/securemessage/read': false,
		'/account/payments/swift/out': false,
		'/account/transactions/readwrite': false,
		'/account/mandates/so/write/recurring': false,
		'/account/sweeps/transfer/out': false,
		'/users/preferences/write': false,
		'/account/books/payin/reorder': false,
		'/account/transactions/write': false,
		'/account/payments/batch/out': false,
		'/account/mandates/so/update': false,
		'/account/sweeps': false,
		'/account/beneficiaries/delete': true,
		'/account/payments/read': false,
		'/account/payments/uk/ics/in': false,
		'/users/read': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/payments/uk/default/out': true,
		'/users/details/write': false,
		'/users/write': false,
		'/account/payments/templates/readwrite': false,
		'/account/transactions/read': true,
		'/account/pots': false,
		'/account/payments/bacscredit/out': true,
		'/account/mandates/so/write': true,
		'/account/payments/transfer/in': true,
		'/user/write': false,
		'/account/statements/order': false,
		'/account/mandates/so/read': true,
		'/account/books/cheque/reorder': false,
		'/account/beneficiaries/import': false,
		'/account/beneficiaries/read': true,
		'/account/beneficiaries/biller/write': true,
		'/account/payments/list/out': false,
		'/account/payments/chaps/out': false,
		'/account/projections': false,
		'/account/read/limited': false,
		'/account/beneficiaries/account/readwrite': true,
		'/account/preferences/paperstatementoptout': false,
		'/account/payments/transfer/out': true,
		'/users/preferences/read': false,
		'/users/security_device/write': false,
		'/account/alerts': false,
		'/account/consent': false,
		'/users/permissions/write': false,
		'/account/read': true,
		'/account/mandates/dd/read': false,
		'/account/statements/read': false,
		'/account/payments/bacsdebit/out': true,
		'/account/securemessage/write': false,
		'/account/mandates/dd/write': false,
		[CAPABILITIES.CHAPS]: false,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: { display_name: null, display_order: 0 },
	displayName: 'CREDIT CARD',
	balances: [
		{ type: 'current', amount: { value: 0, currency: 'GBP' } },
		{ type: 'available', amount: { value: 5900, currency: 'GBP' } },
	],
	code: null,
	showIcon: null,
	display_order: 2,
	sortCode: '************8214',
	bacs: [
		{
			id: '123456',
			type: 'BCR',
			limit: 5000,
			limit_frequency: 'Daily',
		},
		{
			id: '123457',
			type: 'BCR',
			limit: 5000,
			limit_frequency: 'Weekly',
		},
		{
			id: '123458',
			type: 'BDB',
			limit: 5000,
			limit_frequency: 'Fortnightly',
		},
	],
};

export const currentAccount2 = {
	id: '87df0812-6ea2-4167-b330-15f7dc9cb999',
	type: 'current',
	number: '821208-50013514',
	sortcode: null,
	accountNumber: '50013514',
	accountName: 'Current Account 2',
	product: { code: '540', name: 'CURRENT ACCOUNT', description: ' CURRENT ACCOUNT DIRECT' },
	actionsAvailable: {
		'/account/securemessage/read': false,
		'/account/payments/swift/out': false,
		'/account/transactions/readwrite': false,
		'/account/mandates/so/write/recurring': false,
		'/account/sweeps/transfer/out': false,
		'/users/preferences/write': false,
		'/account/books/payin/reorder': false,
		'/account/transactions/write': false,
		'/account/payments/batch/out': false,
		'/account/mandates/so/update': false,
		'/account/sweeps': false,
		'/account/beneficiaries/delete': true,
		'/account/payments/read': false,
		'/account/payments/uk/ics/in': false,
		'/users/read': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/payments/uk/default/out': true,
		'/users/details/write': false,
		'/users/write': false,
		'/account/payments/templates/readwrite': false,
		'/account/transactions/read': true,
		'/account/pots': false,
		'/account/payments/bacscredit/out': false,
		'/account/mandates/so/write': true,
		'/account/payments/transfer/in': true,
		'/user/write': false,
		'/account/statements/order': false,
		'/account/mandates/so/read': true,
		'/account/books/cheque/reorder': false,
		'/account/beneficiaries/import': false,
		'/account/beneficiaries/read': true,
		'/account/beneficiaries/biller/write': true,
		'/account/payments/list/out': false,
		'/account/projections': false,
		'/account/read/limited': false,
		'/account/beneficiaries/account/readwrite': true,
		'/account/preferences/paperstatementoptout': false,
		'/account/payments/transfer/out': true,
		'/users/preferences/read': false,
		'/users/security_device/write': false,
		'/account/alerts': true,
		'/account/consent': false,
		'/users/permissions/write': false,
		'/account/read': true,
		'/account/mandates/dd/read': true,
		'/account/statements/read': true,
		'/account/payments/bacsdebit/out': true,
		'/account/securemessage/write': false,
		'/account/mandates/dd/write': true,
		[CAPABILITIES.CHAPS]: true,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: { display_name: null, display_order: 0, account_name: 'Totally real account name' },
	displayName: 'CURRENT ACCOUNT',
	balances: [
		{ type: 'current', amount: { value: 11, currency: 'GBP' } },
		{ type: 'available', amount: { value: 11, currency: 'GBP' } },
	],
	code: null,
	showIcon: null,
	display_order: 3,
	sortCode: '821208',
	bacs: [
		{
			id: '223456',
			type: 'BDB',
			limit: 5000,
			limit_frequency: 'Monthly',
		},
		{
			id: '323456',
			type: 'BDB',
			limit: 5000,
			limit_frequency: 'Four_Weekly',
		},
	],
};

export const currentAccount2Dupe = {
	id: '87df0812-6ea2-4167-b330-15f7dc9cb99a',
	type: 'current',
	number: '821208-50013514',
	sortcode: null,
	accountNumber: '50013514',
	accountName: 'Current Account 2',
	product: { code: '540', name: 'CURRENT ACCOUNT', description: ' CURRENT ACCOUNT DIRECT' },
	actionsAvailable: {
		'/account/securemessage/read': false,
		'/account/payments/swift/out': false,
		'/account/transactions/readwrite': false,
		'/account/mandates/so/write/recurring': false,
		'/account/sweeps/transfer/out': false,
		'/users/preferences/write': false,
		'/account/books/payin/reorder': false,
		'/account/transactions/write': false,
		'/account/payments/batch/out': false,
		'/account/mandates/so/update': false,
		'/account/sweeps': false,
		'/account/beneficiaries/delete': true,
		'/account/payments/read': false,
		'/account/payments/uk/ics/in': false,
		'/users/read': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/payments/uk/default/out': true,
		'/users/details/write': false,
		'/users/write': false,
		'/account/payments/templates/readwrite': false,
		'/account/transactions/read': true,
		'/account/pots': false,
		'/account/payments/bacscredit/out': false,
		'/account/mandates/so/write': true,
		'/account/payments/transfer/in': true,
		'/user/write': false,
		'/account/statements/order': false,
		'/account/mandates/so/read': true,
		'/account/books/cheque/reorder': false,
		'/account/beneficiaries/import': false,
		'/account/beneficiaries/read': true,
		'/account/beneficiaries/biller/write': true,
		'/account/payments/list/out': false,
		'/account/projections': false,
		'/account/read/limited': false,
		'/account/beneficiaries/account/readwrite': true,
		'/account/preferences/paperstatementoptout': false,
		'/account/payments/transfer/out': true,
		'/users/preferences/read': false,
		'/users/security_device/write': false,
		'/account/alerts': true,
		'/account/consent': false,
		'/users/permissions/write': false,
		'/account/read': true,
		'/account/mandates/dd/read': true,
		'/account/statements/read': true,
		'/account/payments/bacsdebit/out': true,
		'/account/securemessage/write': false,
		'/account/mandates/dd/write': true,
		[CAPABILITIES.CHAPS]: true,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: { display_name: null, display_order: 0, account_name: 'Totally real account name dupe' },
	displayName: 'CURRENT ACCOUNT Dupe',
	balances: [
		{ type: 'current', amount: { value: 11, currency: 'GBP' } },
		{ type: 'available', amount: { value: 11, currency: 'GBP' } },
	],
	code: null,
	showIcon: null,
	display_order: 3,
	sortCode: '821208',
	bacs: [
		{
			id: '223456',
			type: 'BDB',
			limit: 5000,
			limit_frequency: 'Monthly',
		},
		{
			id: '323456',
			type: 'BDB',
			limit: 5000,
			limit_frequency: 'Four_Weekly',
		},
	],
};

export const savingsAccount = {
	id: 'd4e94264-eb9a-4348-ab18-82a5e4c942b2',
	type: 'savings',
	number: '825404-10776013',
	sortcode: '825404',
	accountNumber: '10776013',
	accountName: 'Savings account 1',
	product: { code: '165', name: 'SAVINGS', description: 'CYBERSAVE' },
	actionsAvailable: {
		'/account/securemessage/read': false,
		'/account/payments/swift/out': false,
		'/account/transactions/readwrite': false,
		'/account/mandates/so/write/recurring': false,
		'/account/sweeps/transfer/out': false,
		'/users/preferences/write': false,
		'/account/books/payin/reorder': false,
		'/account/transactions/write': false,
		'/account/payments/batch/out': false,
		'/account/mandates/so/update': false,
		'/account/sweeps': false,
		'/account/beneficiaries/delete': false,
		'/account/payments/read': false,
		'/account/payments/uk/ics/in': false,
		'/users/read': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/payments/uk/default/out': false,
		'/users/details/write': false,
		'/users/write': false,
		'/account/payments/templates/readwrite': false,
		'/account/transactions/read': true,
		'/account/pots': false,
		'/account/payments/bacscredit/out': true,
		'/account/mandates/so/write': true,
		'/account/payments/transfer/in': true,
		'/user/write': false,
		'/account/statements/order': false,
		'/account/mandates/so/read': true,
		'/account/books/cheque/reorder': false,
		'/account/beneficiaries/import': false,
		'/account/beneficiaries/read': false,
		'/account/beneficiaries/biller/write': true,
		'/account/payments/list/out': false,
		'/account/payments/chaps/out': false,
		'/account/projections': false,
		'/account/read/limited': false,
		'/account/beneficiaries/account/readwrite': false,
		'/account/preferences/paperstatementoptout': false,
		'/account/payments/transfer/out': true,
		'/users/preferences/read': false,
		'/users/security_device/write': false,
		'/account/alerts': false,
		'/account/consent': false,
		'/users/permissions/write': false,
		'/account/read': true,
		'/account/mandates/dd/read': false,
		'/account/statements/read': false,
		'/account/payments/bacsdebit/out': false,
		'/account/securemessage/write': false,
		'/account/mandates/dd/write': false,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: { display_name: null, display_order: 0 },
	displayName: 'SAVINGS',
	balances: [
		{ type: 'current', amount: { value: 179.25, currency: 'GBP' } },
		{ type: 'available', amount: { value: 179.25, currency: 'GBP' } },
	],
	code: null,
	showIcon: null,
	display_order: 6,
	sortCode: '825404',
	bacs: [
		{
			id: '423456',
			type: 'BCR',
			limit: 5000,
			limit_frequency: 'Quarterly',
		},
		{
			id: 'No Limit',
			type: 'BCR',
		},
	],
};

export const currentAccountForFasterPayments = {
	id: '1b155dce-f065-43c6-8db6-89bdb57b871c',
	type: 'current',
	number: '826813-10011216',
	sortcode: null,
	accountNumber: '10011216',
	accountName: 'Current - Faster payments',
	product: { code: '395', name: 'CURRENT ACCOUNT', description: 'PROPERTY DEV BASE FACILITY- BUS CURR ACC' },
	actionsAvailable: {
		'/account/securemessage/read': false,
		'/account/payments/swift/out': false,
		'/account/transactions/readwrite': false,
		'/account/mandates/so/write/recurring': false,
		'/account/sweeps/transfer/out': false,
		'/users/preferences/write': false,
		'/account/books/payin/reorder': false,
		'/account/transactions/write': false,
		'/account/payments/batch/out': false,
		'/account/mandates/so/update': false,
		'/account/sweeps': false,
		'/account/beneficiaries/delete': false,
		'/account/payments/read': false,
		'/account/payments/uk/ics/in': false,
		'/users/read': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/payments/uk/default/out': true,
		'/users/details/write': false,
		'/users/write': false,
		'/account/payments/templates/readwrite': false,
		'/account/transactions/read': true,
		'/account/pots': false,
		'/account/payments/bacscredit/out': false,
		'/account/mandates/so/write': false,
		'/account/payments/transfer/in': true,
		'/user/write': false,
		'/account/statements/order': false,
		'/account/mandates/so/read': false,
		'/account/books/cheque/reorder': false,
		'/account/beneficiaries/import': false,
		'/account/beneficiaries/read': true,
		'/account/beneficiaries/biller/write': false,
		'/account/payments/list/out': false,
		'/account/payments/chaps/out': false,
		'/account/projections': false,
		'/account/read/limited': false,
		'/account/beneficiaries/account/readwrite': false,
		'/account/preferences/paperstatementoptout': false,
		'/account/payments/transfer/out': false,
		'/users/preferences/read': false,
		'/users/security_device/write': false,
		'/account/alerts': false,
		'/account/consent': false,
		'/users/permissions/write': false,
		'/account/read': true,
		'/account/mandates/dd/read': false,
		'/account/statements/read': true,
		'/account/payments/bacsdebit/out': false,
		'/account/securemessage/write': false,
		'/account/mandates/dd/write': false,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: { display_name: null, display_order: 0 },
	displayName: 'CURRENT ACCOUNT',
	balances: [
		{ type: 'current', amount: { value: 515, currency: 'GBP' } },
		{ type: 'available', amount: { value: 515, currency: 'GBP' } },
	],
	code: null,
	showIcon: null,
	display_order: 4,
	sortCode: '826813',
	bacs: [
		{
			id: '523456',
			type: 'BCR',
			limit: 5000,
			limit_frequency: 'Weekly',
		},
	],
};

export const fasterPaymentAccountWithBacsCapabilty = {
	id: '1b155dce-f065-43c6-8db6-89bdb57b871d',
	type: 'current',
	number: '826815-10011218',
	sortcode: null,
	accountNumber: '10011218',
	accountName: 'Faster payments BACS',
	product: { code: '395', name: 'CURRENT ACCOUNT', description: 'PROPERTY DEV BASE FACILITY- BUS CURR ACC' },
	actionsAvailable: {
		'/account/securemessage/read': false,
		'/account/payments/swift/out': false,
		'/account/transactions/readwrite': false,
		'/account/mandates/so/write/recurring': false,
		'/account/sweeps/transfer/out': false,
		'/users/preferences/write': false,
		'/account/books/payin/reorder': false,
		'/account/transactions/write': false,
		'/account/payments/batch/out': false,
		'/account/mandates/so/update': false,
		'/account/sweeps': false,
		'/account/beneficiaries/delete': false,
		'/account/payments/read': false,
		'/account/payments/uk/ics/in': false,
		'/users/read': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/payments/uk/default/out': true,
		'/users/details/write': false,
		'/users/write': false,
		'/account/payments/templates/readwrite': false,
		'/account/transactions/read': true,
		'/account/pots': false,
		'/account/payments/bacscredit/out': true,
		'/account/mandates/so/write': false,
		'/account/payments/transfer/in': true,
		'/user/write': false,
		'/account/statements/order': false,
		'/account/mandates/so/read': false,
		'/account/books/cheque/reorder': false,
		'/account/beneficiaries/import': false,
		'/account/beneficiaries/read': true,
		'/account/beneficiaries/biller/write': false,
		'/account/payments/list/out': false,
		'/account/payments/chaps/out': false,
		'/account/projections': false,
		'/account/read/limited': false,
		'/account/beneficiaries/account/readwrite': false,
		'/account/preferences/paperstatementoptout': false,
		'/account/payments/transfer/out': false,
		'/users/preferences/read': false,
		'/users/security_device/write': false,
		'/account/alerts': false,
		'/account/consent': false,
		'/users/permissions/write': false,
		'/account/read': true,
		'/account/mandates/dd/read': false,
		'/account/statements/read': true,
		'/account/payments/bacsdebit/out': true,
		'/account/securemessage/write': false,
		'/account/mandates/dd/write': false,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: { display_name: null, display_order: 0 },
	displayName: 'CURRENT ACCOUNT',
	balances: [
		{ type: 'current', amount: { value: 5151, currency: 'GBP' } },
		{ type: 'available', amount: { value: 5151, currency: 'GBP' } },
	],
	code: null,
	showIcon: null,
	display_order: 5,
	sortCode: '826815',
};

export const iftUSDAccount = {
	id: '82562931-3d0b-4a90-bb7a-11e0f80a6221',
	type: 'CRCURR',
	number: '820000-4503814504750',
	sortcode: null,
	accountNumber: '4503814504750',
	product: {
		code: '1000',
		name: 'CURRENCY ACCOUNT',
		description: 'Currency Account',
	},
	actionsAvailable: {
		'/account/sweeps': false,
		'/account/alerts/transaction/credit': false,
		'/account/payments/bacscredit/approve': false,
		'/case/customer/read': false,
		'/account/payments/batch/out': false,
		'/account/payments/transfer/approve': false,
		'/account/mandates/so/write/recurring': false,
		'/users/preferences/write': false,
		'/account/transactions/read': true,
		'/account/books/cheque/reorder': false,
		'/account/alerts/transaction/debit': false,
		'/case/customer/cancel': false,
		'/case/read': false,
		'/account/read': true,
		'/user/write': false,
		'/account/mandates/so/write': false,
		'/account/payments/bacscredit/out': false,
		'/users/read': false,
		'/account/payments/transfer/out': false,
		'/case/cancel': false,
		'/users/device/manage': false,
		'/account/alerts/balance': false,
		'/account/payments/transfer/in': false,
		'/account/projections': false,
		'/account/sweeps/transfer/out': false,
		'/account/payments/uk/ics/in': false,
		'/users/security_device/write': false,
		'/case/customer/managedocs': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/consent': false,
		'/account/mandates/dd/write': false,
		'/account/payments/list/out': false,
		'/case/reassign': false,
		'/users/preferences/read': false,
		'/account/beneficiaries/import': false,
		'/account/payments/chaps/approve': false,
		'/users/write': false,
		'/account/payments/ift/out': true,
		'/users/permissions/write': false,
		'/account/beneficiaries/read': true,
		'/case/customer/reassign': false,
		'/account/beneficiaries/biller/write': false,
		'/account/beneficiaries/delete': true,
		'/account/payments/read': false,
		'/account/statements/read': false,
		'/account/payments/chaps/out': false,
		'/account/mandates/dd/read': false,
		'/account/payments/templates/readwrite': false,
		'/case/customer/submit': false,
		'/account/transactions/readwrite': false,
		'/case/submit': false,
		'/account/payments/bacsdebit/out': false,
		'/account/payments/ift/approve': false,
		'/user/payments/approve/single': true,
		'/account/payments/uk/default/approve': false,
		'/account/preferences/paperstatementoptout': false,
		'/account/balance/available': true,
		'/account/payments/uk/default/out': false,
		'/account/beneficiaries/account/readwrite': true,
		'/account/statements/order': false,
		'/account/mandates/so/read': false,
		'/users/strands': false,
		'/account/read/limited': false,
		'/case/write': false,
		'/account/alerts': false,
		'/users/details/write': false,
		'/account/books/payin/reorder': false,
		'/account/securemessage/write': false,
		'/case/customer/write': false,
		'/user/payments/approve/dual': false,
		'/account/securemessage/read': false,
		'/account/transactions/write': false,
		'/account/pots': false,
		'/account/mandates/so/update': false,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: {
		display_order: 0,
		account_name: 'Akriti Test',
	},
	displayName: 'CURRENCY ACCOUNT',
	balances: [{ type: 'current', amount: { value: 123.45, currency: 'USD' } }],
	code: null,
	showIcon: null,
	display_order: 11,
	sortCode: '820000',
};

export const iftEURAccount = {
	id: '364f090b-a446-42c9-b606-34a45a581f88',
	type: 'CRCURR',
	number: '820000-4500428577500',
	sortcode: null,
	accountNumber: '4500428577500',
	product: {
		code: '1000',
		name: 'CURRENCY ACCOUNT',
		description: 'Currency Account',
	},
	actionsAvailable: {
		'/account/sweeps': false,
		'/account/alerts/transaction/credit': false,
		'/account/payments/bacscredit/approve': false,
		'/case/customer/read': false,
		'/account/payments/batch/out': false,
		'/account/payments/transfer/approve': false,
		'/account/mandates/so/write/recurring': false,
		'/users/preferences/write': false,
		'/account/transactions/read': true,
		'/account/books/cheque/reorder': false,
		'/account/alerts/transaction/debit': false,
		'/case/customer/cancel': false,
		'/case/read': false,
		'/account/read': true,
		'/user/write': false,
		'/account/mandates/so/write': false,
		'/account/payments/bacscredit/out': false,
		'/users/read': false,
		'/account/payments/transfer/out': false,
		'/case/cancel': false,
		'/users/device/manage': false,
		'/account/alerts/balance': false,
		'/account/payments/transfer/in': false,
		'/account/projections': false,
		'/account/sweeps/transfer/out': false,
		'/account/payments/uk/ics/in': false,
		'/users/security_device/write': false,
		'/case/customer/managedocs': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/consent': false,
		'/account/mandates/dd/write': false,
		'/account/payments/list/out': false,
		'/case/reassign': false,
		'/users/preferences/read': false,
		'/account/beneficiaries/import': false,
		'/account/payments/chaps/approve': false,
		'/users/write': false,
		'/account/payments/ift/out': true,
		'/users/permissions/write': false,
		'/account/beneficiaries/read': true,
		'/case/customer/reassign': false,
		'/account/beneficiaries/biller/write': false,
		'/account/beneficiaries/delete': true,
		'/account/payments/read': false,
		'/account/statements/read': false,
		'/account/payments/chaps/out': false,
		'/account/mandates/dd/read': false,
		'/account/payments/templates/readwrite': false,
		'/case/customer/submit': false,
		'/account/transactions/readwrite': false,
		'/case/submit': false,
		'/account/payments/bacsdebit/out': false,
		'/account/payments/ift/approve': false,
		'/user/payments/approve/single': true,
		'/account/payments/uk/default/approve': false,
		'/account/preferences/paperstatementoptout': false,
		'/account/balance/available': true,
		'/account/payments/uk/default/out': false,
		'/account/beneficiaries/account/readwrite': true,
		'/account/statements/order': false,
		'/account/mandates/so/read': false,
		'/users/strands': false,
		'/account/read/limited': false,
		'/case/write': false,
		'/account/alerts': false,
		'/users/details/write': false,
		'/account/books/payin/reorder': false,
		'/account/securemessage/write': false,
		'/case/customer/write': false,
		'/user/payments/approve/dual': false,
		'/account/securemessage/read': false,
		'/account/transactions/write': false,
		'/account/pots': false,
		'/account/mandates/so/update': false,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: {
		display_order: 0,
		account_name: 'Akriti Test',
	},
	displayName: 'EUR CURRENCY ACCOUNT',
	balances: [{ type: 'current', amount: { value: 123.45, currency: 'EUR' } }],
	code: null,
	showIcon: null,
	display_order: 7,
	sortCode: '820000',
};

export const iftEURAccountNoBalance = {
	id: '364f090b-a446-42c9-b606-34a45a581f80',
	type: 'CRCURR',
	number: '820000-4500428577500',
	accountNumber: '4500428577500',
	product: {
		code: '1000',
		name: 'CURRENCY ACCOUNT',
		description: 'Currency Account',
	},
	actionsAvailable: {
		'/account/sweeps': false,
		'/account/alerts/transaction/credit': false,
		'/account/payments/bacscredit/approve': false,
		'/case/customer/read': false,
		'/account/payments/batch/out': false,
		'/account/payments/transfer/approve': false,
		'/account/mandates/so/write/recurring': false,
		'/users/preferences/write': false,
		'/account/transactions/read': true,
		'/account/books/cheque/reorder': false,
		'/account/alerts/transaction/debit': false,
		'/case/customer/cancel': false,
		'/case/read': false,
		'/account/read': true,
		'/user/write': false,
		'/account/mandates/so/write': false,
		'/account/payments/bacscredit/out': false,
		'/users/read': false,
		'/account/payments/transfer/out': false,
		'/case/cancel': false,
		'/users/device/manage': false,
		'/account/alerts/balance': false,
		'/account/payments/transfer/in': false,
		'/account/projections': false,
		'/account/sweeps/transfer/out': false,
		'/account/payments/uk/ics/in': false,
		'/users/security_device/write': false,
		'/case/customer/managedocs': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/consent': false,
		'/account/mandates/dd/write': false,
		'/account/payments/list/out': false,
		'/case/reassign': false,
		'/users/preferences/read': false,
		'/account/beneficiaries/import': false,
		'/account/payments/chaps/approve': false,
		'/users/write': false,
		'/account/payments/ift/out': true,
		'/users/permissions/write': false,
		'/account/beneficiaries/read': true,
		'/case/customer/reassign': false,
		'/account/beneficiaries/biller/write': false,
		'/account/beneficiaries/delete': true,
		'/account/payments/read': false,
		'/account/statements/read': false,
		'/account/payments/chaps/out': false,
		'/account/mandates/dd/read': false,
		'/account/payments/templates/readwrite': false,
		'/case/customer/submit': false,
		'/account/transactions/readwrite': false,
		'/case/submit': false,
		'/account/payments/bacsdebit/out': false,
		'/account/payments/ift/approve': false,
		'/user/payments/approve/single': true,
		'/account/payments/uk/default/approve': false,
		'/account/preferences/paperstatementoptout': false,
		'/account/balance/available': true,
		'/account/payments/uk/default/out': false,
		'/account/beneficiaries/account/readwrite': true,
		'/account/statements/order': false,
		'/account/mandates/so/read': false,
		'/users/strands': false,
		'/account/read/limited': false,
		'/case/write': false,
		'/account/alerts': false,
		'/users/details/write': false,
		'/account/books/payin/reorder': false,
		'/account/securemessage/write': false,
		'/case/customer/write': false,
		'/user/payments/approve/dual': false,
		'/account/securemessage/read': false,
		'/account/transactions/write': false,
		'/account/pots': false,
		'/account/mandates/so/update': false,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: {
		display_order: 0,
		account_name: 'Akriti Test',
	},
	displayName: 'EUR CURRENCY ACCOUNT NO BALANCE',
	currency: 'EUR',
	balances: null,
	code: null,
	showIcon: null,
	display_order: 7,
	sortCode: '820000',
};

export const iftEURAccountNoBalance2 = {
	id: 'fbfbf663-3813-4639-a912-308b9060f975',
	type: 'current',
	number: '823000-10018229',
	accountNumber: '10018229',
	product: {
		code: '220',
		name: 'Business Current',
		description: 'STANDARD BUSINESS',
	},
	actionsAvailable: {
		'/account/sweeps': false,
		'/account/alerts/transaction/credit': false,
		'/account/payments/bacscredit/approve': false,
		'/case/customer/read': false,
		'/account/payments/batch/out': false,
		'/account/payments/transfer/approve': false,
		'/account/mandates/so/write/recurring': false,
		'/users/preferences/write': false,
		'/account/transactions/read': false,
		'/account/books/cheque/reorder': false,
		'/account/alerts/transaction/debit': false,
		'/case/customer/cancel': false,
		'/case/read': false,
		'/account/read': false,
		'/user/write': false,
		'/account/mandates/so/write': true,
		'/account/payments/bacscredit/out': true,
		'/users/read': false,
		'/account/payments/transfer/out': true,
		'/case/cancel': false,
		'/users/device/manage': false,
		'/account/alerts/balance': false,
		'/account/payments/transfer/in': true,
		'/account/projections': false,
		'/account/sweeps/transfer/out': false,
		'/account/payments/uk/ics/in': false,
		'/users/security_device/write': false,
		'/case/customer/managedocs': false,
		'/users/security_device/read': false,
		'/account/payments/alerts': false,
		'/account/consent': false,
		'/account/mandates/dd/write': false,
		'/account/payments/list/out': false,
		'/case/reassign': false,
		'/users/preferences/read': false,
		'/account/beneficiaries/import': false,
		'/account/payments/chaps/approve': false,
		'/users/write': false,
		'/account/payments/ift/out': true,
		'/users/permissions/write': false,
		'/account/beneficiaries/read': true,
		'/case/customer/reassign': false,
		'/account/beneficiaries/biller/write': true,
		'/account/beneficiaries/delete': true,
		'/account/payments/read': true,
		'/account/statements/read': false,
		'/account/payments/chaps/out': true,
		'/account/mandates/dd/read': false,
		'/account/payments/templates/readwrite': false,
		'/case/customer/submit': false,
		'/account/transactions/readwrite': false,
		'/case/submit': false,
		'/account/payments/bacsdebit/out': true,
		'/account/payments/ift/approve': false,
		'/user/payments/approve/single': false,
		'/account/payments/uk/default/approve': false,
		'/account/preferences/paperstatementoptout': false,
		'/account/balance/available': true,
		'/account/payments/uk/default/out': true,
		'/account/beneficiaries/account/readwrite': true,
		'/account/statements/order': false,
		'/account/mandates/so/read': false,
		'/users/strands': false,
		'/account/read/limited': true,
		'/case/write': false,
		'/account/alerts': false,
		'/users/details/write': false,
		'/account/books/payin/reorder': false,
		'/account/securemessage/write': false,
		'/case/customer/write': false,
		'/user/payments/approve/dual': false,
		'/account/securemessage/read': false,
		'/account/transactions/write': false,
		'/account/pots': false,
		'/account/mandates/so/update': false,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
	},
	bank_id: 'CB',
	metadata: {
		display_order: 0,
		account_name: 'MR BUSH BOND & MR BUDDI BOND',
	},
	displayName: 'Business Current',
	balances: null,
	currency: 'GBP',
	code: null,
	showIcon: null,
	display_order: 1,
	accountName: 'MR BUSH BOND & MR BUDDI BOND',
	sortCode: '823000',
	bacs: [
		{
			uuid: 'fc4d294e-11af-4e01-8938-2243e0b0e536',
			id: '454354',
			type: 'BDB',
			limit: 543543,
			limit_frequency: 'Weekly',
		},
		{
			uuid: '25fce52e-fe34-4a68-a4d1-5bc37900bd19',
			id: '545455',
			type: 'BCR',
			limit: 554354,
			limit_frequency: 'Daily',
		},
	],
};

export const business30dayNoticesavingsAccount = {
	id: '68ac1463-6fec-4220-abe4-ef2af22f0715',
	type: 'savings',
	number: '050732-21555515',
	sortcode: '050732',
	accountNumber: '21555515',
	accountName: 'PP Engineering No 2 account',
	product: { code: '720', name: '30 Day Notice Bus', description: 'CYBERSAVE' },
	actionsAvailable: {
		'/account/read': true,
		'/account/transactions/read': true,
		'/account/transactions/write': true,
		'/account/transactions/readwrite': false,
		'/account/payments/transfer/in': true,
		'/account/payments/transfer/out': false,
		'/account/payments/uk/default/out': false,
		'/account/beneficiaries/read': false,
		'/account/beneficiaries/delete': false,
		'/account/beneficiaries/account/readwrite': false,
		'/account/mandates/so/read': true,
		'/account/mandates/so/write': true,
		'/account/mandates/dd/read': false,
		'/account/mandates/dd/write': false,
		'/account/pots': false,
		'/account/sweeps': false,
		'/account/sweeps-out': false,
		'/account/sweeps-in': false,
		'/account/alerts': false,
		'/account/alerts/balance': false,
		'/account/alerts/transaction/debit': false,
		'/account/alerts/transaction/credit': false,
		'/account/projections': false,
		'/account/statements/read': true,
		'/account/preferences/paperstatementoptout': false,
		'/account/payments/uk/ics/in': true,
		'/account/statements/order': true,
		'/account/books/cheque/reorder': false,
		'/account/books/payin/reorder': false,
		'/account/payments/alerts': false,
		'/users/card/manage': false,
		'/account/consent': false,
		'/account/read/limited': true,
		'/account/payments/list/out': false,
		'/account/payments/batch/out': false,
		'/account/payments/bacsdebit/out': false,
		'/account/payments/bacscredit/out': false,
		'/account/payments/chaps/out': false,
		'/account/payments/swift/out': false,
		'/account/payments/ift/out': false,
		'/account/payments/templates/readwrite': false,
		'/account/payments/read': true,
		'/account/beneficiaries/import': false,
		'/account/payments/transfer/approve': false,
		'/account/payments/uk/default/approve': false,
		'/account/payments/chaps/approve': false,
		'/account/payments/ift/approve': false,
		'/account/payments/bacscredit/approve': false,
		'/account/pools/write': true,
		[CAPABILITIES.EFFECTIVEWARNING]: true,
		'/account/balance/available': false,
		'/users/details/address/write': false,
		'/users/details/mobile/write': false,
		'/users/details/home/write': false,
		'/users/details/email/write': false,
		'/account/propogate/address': false,
		'/account/propogate/mobile': false,
		'/account/propogate/home': false,
		'/account/propogate/email': false,

		'/users/details/write': false,
		'/account/securemessage/read': false,
		'/account/mandates/so/write/recurring': false,
		'/account/sweeps/transfer/out': false,
		'/users/preferences/write': false,
		'/account/mandates/so/update': false,
		'/users/read': false,
		'/users/security_device/read': false,
		'/users/write': false,
		'/user/write': false,
		'/account/beneficiaries/biller/write': true,
		'/users/preferences/read': false,
		'/users/security_device/write': false,
		'/users/permissions/write': false,
		'/account/securemessage/write': false,
	},
	bank_id: 'CB',
	metadata: { display_name: null, display_order: 0 },
	displayName: 'PP Engineering No 2 account',
	balances: [
		{ type: 'current', amount: { value: 179.25, currency: 'GBP' } },
		{ type: 'available', amount: { value: 179.25, currency: 'GBP' } },
	],
	code: null,
	showIcon: null,
	display_order: 6,
	sortCode: '050732',
	bacs: [
		{
			id: '423456',
			type: 'BCR',
			limit: 5000,
			limit_frequency: 'Quarterly',
		},
		{
			id: 'No Limit',
			type: 'BCR',
		},
	],
};

export default [
	currentAccount,
	creditCard,
	currentAccount2,
	savingsAccount,
	iftEURAccount,
	iftEURAccountNoBalance,
	iftEURAccountNoBalance2,
	business30dayNoticesavingsAccount,
	currentAccountForFasterPayments,
	{
		id: 'da242f55-7c7a-4acf-9746-f3e8b9128762',
		type: 'current',
		number: '826817-41640012',
		sortCode: '826817',
		accountNumber: '41640012',
		accountName: 'Current Account 3',
		product: { code: '250', name: 'CURRENT ACCOUNT', description: 'PFCA' },
		actionsAvailable: {
			'/account/securemessage/read': false,
			'/account/payments/swift/out': false,
			'/account/transactions/readwrite': false,
			'/account/mandates/so/write/recurring': false,
			'/account/sweeps/transfer/out': false,
			'/users/preferences/write': false,
			'/account/books/payin/reorder': false,
			'/account/transactions/write': false,
			'/account/payments/batch/out': false,
			'/account/mandates/so/update': false,
			'/account/sweeps': false,
			'/account/beneficiaries/delete': false,
			'/account/payments/read': false,
			'/account/payments/uk/ics/in': false,
			'/users/read': false,
			'/users/security_device/read': false,
			'/account/payments/alerts': false,
			'/account/payments/uk/default/out': true,
			'/users/details/write': false,
			'/users/write': false,
			'/account/payments/templates/readwrite': false,
			'/account/transactions/read': true,
			'/account/pots': false,
			'/account/payments/bacscredit/out': true,
			'/account/mandates/so/write': true,
			'/account/payments/transfer/in': true,
			'/user/write': false,
			'/account/statements/order': false,
			'/account/mandates/so/read': true,
			'/account/books/cheque/reorder': false,
			'/account/beneficiaries/import': false,
			'/account/beneficiaries/read': false,
			'/account/beneficiaries/biller/write': false,
			'/account/payments/list/out': false,
			'/account/payments/chaps/out': false,
			'/account/projections': false,
			'/account/read/limited': false,
			'/account/beneficiaries/account/readwrite': false,
			'/account/preferences/paperstatementoptout': false,
			'/account/payments/transfer/out': true,
			'/users/preferences/read': false,
			'/users/security_device/write': false,
			'/account/alerts': false,
			'/account/consent': false,
			'/users/permissions/write': false,
			'/account/read': true,
			'/account/mandates/dd/read': true,
			'/account/statements/read': true,
			'/account/payments/bacsdebit/out': false,
			'/account/securemessage/write': false,
			'/account/mandates/dd/write': true,
			[CAPABILITIES.EFFECTIVEWARNING]: true,
		},
		bank_id: 'CB',
		metadata: { display_name: null, display_order: 0 },
		displayName: 'CURRENT ACCOUNT',
		balances: [],
		code: null,
		showIcon: null,
		display_order: 5,
		bacs: [
			{
				id: '523456',
				type: 'BCR',
				limit: 5000,
				limit_frequency: 'Weekly',
			},
		],
	},
];

export const accountsOnlyForFasterPayments = [currentAccountForFasterPayments, fasterPaymentAccountWithBacsCapabilty];
export const role100IFTPayments = [iftEURAccountNoBalance, iftEURAccountNoBalance2];
